<template>
  <!--  这是一个用于输入信息时弹出平铺选择面板组件，包含常用、历史和输入查询结果的展示  -->
  <el-popover
    placement="right"
    :width="componentsWidth"
    v-model="visibleAdd"
    @show="showAdd"
    @hide="hideAdd"
    trigger="click">
    <div>
      <div class="kh_title_lr">
        <div class="title_left_name">选择{{modeName}}</div>
        <div class="title_right_clear" @click="clearnData">清空</div>
      </div>


      <div v-if="unQueryName" @mousedown.stop="cancelDown">
        <div class="nodata-imgbg">
          <img class="nodata-img" src="../../assets/img/nodata.png"/>
        </div>

        <div class="one-text">
          未查询到关于"{{showName}}"的数据！点击下方"确定"，添加此数据。
        </div>
        <div class="two-text">
          快捷新增数据
        </div>
        <div class="add-info-txt">
          新增{{modeName}}：<span class="kh-name">{{showName}}</span>
        </div>
        <div class="add-info-btnbg">
          <el-button size="small" :loading="reqing" @click="adddata" type="primary">确认</el-button>
        </div>
        <!--                <div class="add-info-txt2">您可以通过点击上方"确认"按钮直接新增"{{showName}}"到系统{{modeName}}中</div>-->
      </div>


      <section v-if="!unQueryName">
        <div v-if="querylist!=null&&querylist.length>0">
          <div style="color: #46A0FC;">
            查询结果：
          </div>
          <div class="kh_content"
               style="border-bottom: 1px solid #bcbec252;margin-bottom: 10px;padding-bottom: 10px">
            <el-tag
              @click="clickTag(item[keyStr],0)"
              class="kh_item1"
              v-for="(item,index)  in querylist"
              :key="index"
              :type="valObj[keyStr]==item[keyStr]?'success':'info'"
            >
              {{item[valStr]}}
            </el-tag>
          </div>
        </div>

<!--        <div style="color: #46A0FC;" v-if="show">-->
<!--        常用{{modeName}}：-->
<!--      </div>-->
<!--        <div style="color: #46A0FC;" v-else-if="showyewu">-->
<!--          常用{{modeName}}：-->
<!--        </div>-->
<!--        <div  class="kh_content" style="border-bottom: 1px solid #bcbec252;margin-bottom: 10px;padding-bottom: 10px">-->
<!--          <el-tag ref="divtag"  v-if="getValueStr(item) == '&#45;&#45;'? false: true "-->
<!--            @click="clickTag(item,0)"-->
<!--            class="kh_item1"-->
<!--            v-for="(item,index)  in commonlist"-->
<!--            :key="index"-->
<!--            :type="valObj[keyStr]==item?'success':'info'"-->
<!--          >-->
<!--            {{getValueStr(item,1)}}-->
<!--            &lt;!&ndash; {{item}} &ndash;&gt;-->
<!--          </el-tag>-->
<!--        </div>-->

        <div style="color: #6AC144;">
          历史记录：
        </div>
        <div class="kh_content">
          <el-tag
            @click="clickTag(item,0)"
            class="kh_item1"
            v-for="(item,index)  in recordlist"
            :key="index"
            :type="valObj[keyStr]==item?'success':'info'"
          >
            {{getValueStr(item,0)}}
          </el-tag>
          <div class="zanwujilu"
               v-if="recordlist==null||recordlist.length==0">
            暂无记录
          </div>
        </div>
      </section>


    </div>
    <el-input slot="reference" :placeholder="'请录入'+modeName+'名称'" @input="inputShowName" v-model="showName"  @clear="clearInput"></el-input>
  </el-popover>
</template>

<script>

  import {commonreq} from "../../api/commonreq";
  import {getCommonAndRecordByKey, saveRecord} from "../../api/panelSelection";
  import {ERR_OK} from "../../jslib/config";

  export default {
    data() {
      return {
        visibleAdd: false,//是否显示弹出选择面板
        showName: '',//输入框中展示选中的名称
        valObj: {},//用户最终选择的对象

        commonlist: [],//常用数据列表
        recordlist: [],//用户使用记录列表
        querylist: [],//用户输入后查询列表
        tempShow: null,
        unQueryName: false,
        reqing: false,
        show: false,
        showyewu: false
      }
    },
    props: {
      allData: Array,//全部对象列表
      modeName: String,
      keyStr: String,//数据对象中的key对应的字符
      valStr: String,//数据对象中展示文本对应的字符
      dataKey: String,//后台常用数据、用户记录数据储存对应的key
      isYewu: false,
      addUrl: String,//新增数据接口地址，上传参数{name:***}，返回结果格式{id:***}。需要返回新增数据的id字符串
      componentsWidth: {
        type: String,
        required: false,
        default: "400"
      }
    },
    created() {
      getCommonAndRecordByKey(this.dataKey).then(res => {
        if (res != undefined && res.resultCode === ERR_OK) {
          this.commonlist = res.commonlist
          this.recordlist = res.recordlist
        }
      })
    },
    mounted() {
      console.log(this.isYewu)
    },
    methods: {
      cancelDown(e) {
        // console.log(e)
      },
      clearInput(){
        this.$emit("clearInput", null)
      },
      adddata() {
        if (this.addUrl == undefined || this.addUrl.length <= 0) {
          this.$message({
            message: '当前面板未设置新增接口请设置新增接口！',
            type: 'warning'
          });
          return;
        }
        var that = this
        this.reqing = true
        commonreq({
          name: this.showName
        }, this.addUrl).then(res => {
          if (res !== undefined && res.resultCode === ERR_OK) {
            var obj = {}
            obj[that.keyStr] = res.id
            obj[that.valStr] = that.showName
            that.allData.push(obj);
            that.clickTag(res.id,0);
            that.reqing = false
          }
        })
      },
      showAddDataView() {
        if (this.addUrl == undefined || this.addUrl.length <= 0) {
          console.log("当前面板未设置新增接口！不在显示快捷新增界面")
          return;
        }

        this.unQueryName = true
      },
      clean() {
        this.valObj = {}
        this.showName = ''
      },
      clearnData(){
        this.clean()
        this.clickTag(this.valObj,1)
      },
      getValueStr(keyVal,inde) {
        var v = "--";
        for (var i = 0; i < this.allData.length; i++) {
          var tmp = this.allData[i];
          if (tmp[this.keyStr] == keyVal) {
              if (this.isYewu == undefined){
                  this.show = true
                return tmp[this.valStr]
              }else{
                if ((tmp[this.valStr] != null || tmp[this.valStr] != '')  && inde == 1){
                  this.showyewu = true
                }
                return tmp[this.valStr]
              }

          }
        }
        return v


      },
      showAdd() {
        this.querylist = []
        if (this.showName == undefined || this.showName.length <= 0) {
          this.unQueryName = false
        } else {
          this.inputShowName()
        }

        if(this.recordlist!=undefined&&this.recordlist!=null&&this.recordlist.length>0){
          //删除历史数据中，已经查询不到名称的id
          var newrecordlist = []
          for (var i = 0; i < this.recordlist.length; i++) {
            var tmp = this.recordlist[i];
            var vs = this.getValueStr(tmp);
            if (vs != '--') {
              newrecordlist.push(tmp);
            }
          }
          this.recordlist = newrecordlist;
        }
        this.notifyParentopen()
      },
      hideAdd() {
        console.log("执行了关闭窗口的方法！")
        if (this.valObj == null || this.valObj[this.keyStr] == undefined) {
          if (this.showName != undefined && this.showName != null && this.showName.length > 0) {
            this.$message({
              message: '请点击选择一个' + this.modeName + "!",
              type: 'warning'
            });
          }
          this.showName = ''
        } else {
          this.showName = this.valObj[this.valStr]
        }
        this.notifyParent()
      },
      choseKey(id) {
        var that = this
        if (this.allData == undefined ||
          this.allData == null ||
          this.allData.length <= 0) {
          setTimeout(function () {
            that.choseKey(id)
          }, 100)
          return
        }
        for (var i = 0; i < this.allData.length; i++) {
          var tmp = this.allData[i];
          if (tmp[this.keyStr] == id) {
            this.valObj = tmp
            break;
          }
        }
        this.showName = this.valObj[this.valStr]
      },
      clickTag(id,item) {
        this.choseKey(id)
        // if(item == 0){
          this.visibleAdd = false
        // }else {
        //   this.visibleAdd =true
        // }


        if (!this.recordlistHave(this.valObj[this.keyStr])) {
          var newarr = [];
          newarr.push(this.valObj[this.keyStr])

          if (this.recordlist != undefined && this.recordlist != null && this.recordlist.length > 0) {
            for (var i = 0; i < this.recordlist.length; i++) {
              if (newarr.length <= 10) {
                newarr.push(this.recordlist[i]);
              }
            }
          }

          this.recordlist = newarr;
          //调用后台接口储存到历史记录
          saveRecord(this.dataKey, this.valObj[this.keyStr])

        }
        this.notifyParent()
        // console.log("返回的结果是："+id)
      },
      recordlistHave(id) {
        if (this.recordlist == undefined || this.recordlist == null || this.recordlist.length <= 0) {
          return false
        }
        for (var i = 0; i < this.recordlist.length; i++) {
          var tmp = this.recordlist[i]
          if (tmp == id) {
            return true;
          }
        }
        return false;

      },
      inputShowName() {
        // console.log(this.showName)
        if (this.showName == undefined || this.showName == null || this.showName == '') {
          this.querylist = []
          this.unQueryName = false
          return
        }
        if (this.visibleAdd == false) {
          this.visibleAdd = true
        }
        var qlist = [];
        for (var i = 0; i < this.allData.length; i++) {
          var tmp = this.allData[i];
          if(tmp[this.valStr]==null){
            continue;
          }
          var fdStart = tmp[this.valStr].indexOf(this.showName);
          if (fdStart == 0) {
            qlist.push(tmp);
          }
          if (qlist.length >= 10) {
            this.querylist = qlist
            this.checkQueryList();
            return
          }
        }
        this.querylist = qlist
        this.checkQueryList();
      },
      checkQueryList() {
        if (this.querylist === undefined || this.querylist.length <= 0) {
          this.showAddDataView()
        } else {
          console.log(this.querylist)
          this.unQueryName = false
        }
      },
      notifyParent() {
        this.$emit("setVal", this.valObj)
      },
      notifyParentopen() {
        this.$emit("openCom", this.valObj)
      }
    }
  }
</script>

<style scoped>
  .kh-name {
    color: #F56C6C;
  }

  .add-info-btnbg {
    margin-top: 10px;
    text-align: center;
    margin-bottom: 20px;
  }

  .add-info-txt {
    margin-top: 20px;
    text-align: center;
  }

  .add-info-txt2 {
    font-size: 0.7rem;
    color: #47cc389c;
    margin-top: 20px;
  }

  .two-text {
    border-top: 1px dashed #e2e2e2;
    padding-top: 10px;
    margin-top: 10px;
    color: #409EFF;
  }

  .one-text {
    color: rgb(154, 154, 154);
    text-align: center;
    margin-top: 4px;
    font-size: 0.7rem;
  }

  .nodata-imgbg {
    text-align: center;
    margin-top: 20px;
  }

  .nodata-img {
    width: 80px;
  }

  .kh_item1 {
    margin: 5px 5px;
  }

  .kh_title {
    font-size: 1.2rem;
    color: #BCBEC2;
    border-bottom: 1px solid #bcbec252;
    margin-bottom: 10px;
  }

  .kh_content {
    display: flex;
    flex-wrap: wrap;
  }
.title_left_name{
    width: 50%;
    text-align: left;
  }
  .title_right_clear{
    width: 50%;
    text-align: right;
    font-size: 1rem;
    color: #409eff;
    cursor: pointer;
  }
  .kh_title_lr{
    display: flex;
    font-size: 1.2rem;
    color: #BCBEC2;
    border-bottom: 1px solid #bcbec252;
    margin-bottom: 10px;
  }
  .zanwujilu {
    width: 100%;
    text-align: center;
    padding: 10px 0px;
    color: #BCBEC2;
  }
  .el-input{
    width:100%;
  }
</style>
